import React, { Suspense } from 'react';
import Header from './components/Header';
import Home from './pages/Home';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/i18n';
// import { Router } from 'react-router-dom';
import { Route, Routes, useLocation } from 'react-router-dom';
import TermsOfUse from './pages/TermsOfUse';
import LinksPage from './pages/LinksPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
// import WithLocation from './WithLocation';

// Wrapper to inject location into a class component
function withLocation(Component) {
  return function ComponentWithRouterProp(props) {
    const location = useLocation();
    return <Component {...props} location={location} />;
  };
}

class App extends React.Component {
  render() {
    const { location } = this.props;
    const hideLayoutRoutes = ['/links'];
    const hideLayout = hideLayoutRoutes.includes(location.pathname);

    return (
      <I18nextProvider i18n={i18n}>
        <div className="min-h-screen bg-gray-50">
          <Suspense fallback="Loading...">
            {!hideLayout && <Header />}
            <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/terms-of-use" element={<TermsOfUse />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/links" element={<LinksPage />} />
                </Routes>
              </main>
          </Suspense>
        </div>
    </I18nextProvider>
    );
  }
}

export default withLocation(App);